var _path, _path2, _path3, _path4, _path5, _g, _rect, _path6, _rect2, _path7, _circle, _path8, _rect3, _path9, _path0, _path1, _path10, _g2, _path11, _path12, _path13, _path14, _path15, _rect4, _path16, _path17, _path18, _circle2, _path19, _path20, _path21, _path22, _path23, _rect5, _rect6, _ellipse, _circle3, _circle4, _path24, _path25, _path26, _path27, _rect7, _rect8, _path28, _path29, _path30, _path31;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndrawAdventureMap3E4P(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800.249,
    height: 643.989,
    viewBox: "0 0 800.249 643.989",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-543.986 -268)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.805,0,16.947,2.188v12.96H0Z",
    transform: "matrix(0.951, -0.309, 0.309, 0.951, 1149.774, 614.104)",
    fill: "#ed9da0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M710.357,771.186s-12.713-31.293,25.426-54.763Z",
    transform: "translate(329.179 139.165)",
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M694.574,770.717s-3.878-22.3-33.894-22.113Z",
    transform: "translate(358.516 139.065)",
    fill: "#e6e6e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M982.31,771.131s-16.8-41.343,33.591-72.349Z",
    transform: "translate(328.334 139.22)",
    fill: "#e6e6e6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M961.458,770.511s-5.123-29.467-44.779-29.214",
    transform: "translate(328.53 139.088)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(543.986 268)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(462.878 168.495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M492.887,185.091l-26.31-13.975,1.969-1.047,26.31,13.977Z",
    transform: "translate(-466.576 -170.069)",
    fill: "#0284C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.424,185.091l-1.967-1.045,26.309-13.977,1.969,1.047Z",
    transform: "translate(-466.064 -170.069)",
    fill: "#0284C7"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.755,
    height: 5.265,
    transform: "translate(342.99 112.277) rotate(-62.868)",
    fill: "#cbcbcb"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M626.038,289.839l-9.326-4.779.8-1.562,9.326,4.779Zm-18.653-9.558-9.327-4.78.8-1.562,9.327,4.78Zm-18.653-9.559-9.326-4.779.8-1.562,9.326,4.779Zm-18.653-9.558-9.327-4.779.8-1.562,9.327,4.779Zm-18.653-9.558-9.326-4.779.8-1.562,9.326,4.779Z",
    transform: "translate(-185.101 -127.368)",
    fill: "#cbcbcb"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.755,
    height: 5.265,
    transform: "translate(450.267 167.249) rotate(-62.868)",
    fill: "#cbcbcb"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M281.4,355.843q0,.822-.053,1.631a24.705,24.705,0,0,1-2.315,8.969c-.01.024-.022.046-.033.069-.062.131-.126.261-.191.39a24.391,24.391,0,0,1-1.315,2.32,24.826,24.826,0,0,1-20.375,11.466l.246,14.133,3.2-1.688.572,1.088-3.753,1.976.459,26.248.005.351-2.478.552.005-.352.78-42.306a24.777,24.777,0,0,1-17.529-7.627c-.156-.161-.311-.328-.462-.493l-.017-.019a24.878,24.878,0,0,1-4.527-7c.024.027.05.053.074.081a24.857,24.857,0,0,1,11.785-32.03l.26-.127a24.876,24.876,0,0,1,32.227,9.783c.151.254.3.514.438.775a24.721,24.721,0,0,1,2.99,11.815Z",
    transform: "translate(-184.134 -127.635)",
    fill: "#e5e5e5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.572,
    cy: 32.572,
    r: 32.572,
    transform: "translate(61.35 173.745)",
    fill: "#0284C7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M254.05,312.138a32.575,32.575,0,0,0,54.275,34.474,32.575,32.575,0,1,1-54.275-34.474Z",
    transform: "translate(-184.178 -127.576)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M95.973,297.7l-3.327-.933.007-.358,1-54.181.05-2.7v-.079l.174-9.466.252-13.72v0l.171-9.3h.092l.175,10.076.228,13.114.163,9.3v.069l.007.384v0l.316,18.138.033,1.8.653,37.49Z",
    transform: "translate(-0.288 -0.644)",
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 6.085,
    height: 1.611,
    transform: "translate(93.808 258.029) rotate(-27.766)",
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M700.143,228.212a829.677,829.677,0,0,0-123.366,1.9c-19.77,1.787-39.854,3.717-59.259,8.03-15.63,3.474-33.77,9.344-43.508,23.018a22.221,22.221,0,0,0-3.469,19.453c2.322,7.8,8.1,14.284,14.25,19.366,14.158,11.7,31.725,18.5,47.417,27.8,28.651,16.967,54.872,39.835,71.7,68.886,7.406,12.783,14.451,29.781,6.2,43.867-8.079,13.8-26.114,18.554-40.822,20.8-18.435,2.81-37.424,2.048-55.936.474a582.811,582.811,0,0,1-60.462-8.856c-39.153-7.518-77.949-17.081-117.645-21.43a340.714,340.714,0,0,0-59.982-1.735c-18.068,1.219-36.291,4.077-53.264,10.592-13.08,5.02-27.022,12.616-34.087,25.283-6.81,12.211-4.154,26.292,3.262,37.558,8.923,13.555,22.836,22.844,37.3,29.633,16.47,7.73,34.087,12.741,51.725,17,8.946,2.161,17.94,4.115,26.935,6.059,1.876.405,2.678-2.477.8-2.884-18.14-3.92-36.332-7.852-54.021-13.526-16.369-5.251-33.121-11.977-46.526-23-10.845-8.92-21.156-21.948-20.516-36.761.645-14.933,13.174-25.359,25.454-31.777,15.347-8.02,32.783-11.927,49.868-13.969a303,303,0,0,1,58.907-.8c39.6,3.013,78.321,12.035,117.151,19.9,37.722,7.644,76.621,14.723,115.279,12.762,15.322-.777,31.74-2.973,45.269-10.707,6.194-3.541,11.78-8.535,14.928-15.034a33.669,33.669,0,0,0,2.573-19.783c-2.194-14.724-10.939-28.377-19.665-40.1A193.811,193.811,0,0,0,563.6,345.995a260.592,260.592,0,0,0-43.713-28.476c-8.213-4.324-16.542-8.482-24.368-13.49-7.5-4.8-14.907-10.58-19.489-18.375-3.964-6.742-4.691-14.437-.562-21.275,4.176-6.916,11.37-11.74,18.464-15.265,17.093-8.493,36.965-10.766,55.665-13.1a823.36,823.36,0,0,1,121.072-6.037q14.748.347,29.477,1.221c1.923.113,1.916-2.878,0-2.991Z",
    transform: "translate(-183.986 -127.311)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M675.564,132.036l6.21-4.967c-4.824-.532-6.807,2.1-7.618,4.181-3.769-1.565-7.872.486-7.872.486l12.425,4.511A9.4,9.4,0,0,0,675.564,132.036Z",
    transform: "translate(-185.487 -127)",
    fill: "#3f3d56"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M645.332,147.81l6.21-4.967c-4.824-.532-6.807,2.1-7.618,4.181-3.769-1.565-7.872.486-7.872.486l12.425,4.511a9.4,9.4,0,0,0-3.145-4.211Z",
    transform: "translate(-185.393 -127.049)",
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M675.564,172.784l6.21-4.967c-4.824-.532-6.807,2.1-7.618,4.181-3.769-1.565-7.872.486-7.872.486L678.71,177a9.4,9.4,0,0,0-3.145-4.211Z",
    transform: "translate(-185.487 -127.127)",
    fill: "#3f3d56"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(363.521 15.2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.71,
    cy: 18.71,
    r: 18.71,
    transform: "translate(14.748 0.395)",
    fill: "#ff6583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.771,219.008H548.985a1.881,1.881,0,0,1-.343-.027l43.412-75.189a3.039,3.039,0,0,1,5.291,0l29.133,50.456,1.4,2.414Z",
    transform: "translate(-548.642 -142.248)",
    fill: "#0284C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.073,219.078H612.687l15.383-22.345,1.107-1.61L649.222,166a4.056,4.056,0,0,1,6.025-.36,3.616,3.616,0,0,1,.289.36Z",
    transform: "translate(-548.841 -142.317)",
    fill: "#0284C7"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M560.725,392.235c8.7,4.348,14,10.091,14,16.391,0,13.57-24.555,24.57-54.844,24.57-13.169,0-25.25-2.081-34.7-5.547,10.042,5.019,24.618,8.179,40.847,8.179,30.289,0,54.844-11,54.844-24.57C580.864,403.588,573.015,396.741,560.725,392.235Z",
    transform: "translate(-184.924 -127.826)",
    fill: "#f1f1f1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M580.107,401.585c9.817,4.907,15.794,11.387,15.794,18.495,0,15.312-27.707,27.724-61.885,27.724-14.86,0-28.492-2.348-39.16-6.259,11.331,5.663,27.778,9.229,46.091,9.229,34.178,0,61.885-12.413,61.885-27.724C602.831,414.4,593.975,406.669,580.107,401.585Z",
    transform: "translate(-184.954 -127.855)",
    fill: "#f1f1f1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M553.365,396.353c6.129,3.064,9.861,7.11,9.861,11.548,0,9.56-17.3,17.31-38.639,17.31a72.572,72.572,0,0,1-24.45-3.908c7.074,3.536,17.344,5.762,28.778,5.762,21.339,0,38.639-7.75,38.639-17.31C567.554,404.352,562.024,399.528,553.365,396.353Z",
    transform: "translate(-184.97 -127.839)",
    fill: "#f1f1f1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M467.141,394.593s1.347,19.687,39.957,19.687,50.137-19.687,50.137-19.687Z",
    transform: "translate(-184.867 -127.833)",
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M522.043,342.76a27.1,27.1,0,0,0-19.523-5.34,27.2,27.2,0,0,1-3.293,53.462,27.2,27.2,0,0,0,22.816-48.122Z",
    transform: "translate(-184.967 -127.655)",
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2.632,
    height: 62.662,
    transform: "translate(321.791 206.212)",
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M682.947,287.021l-.014-.024-.036-1.531,8.247-11.974-8.237,10.828-.029.324-.282-12.239,7.123-12.414-7.143,10.264.075-25.356v-.084l0,.083-.473,19.984-6.492-8.117,6.471,9.839-.142,10.947-5.974-10.684,5.952,12.294-.079,6.087-.218,16.865-.016,1.26q.825.006,1.634-.027l-.374-16.2Z",
    transform: "translate(-185.517 -127.367)",
    fill: "#cbcbcb"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M643.336,292.3l-.014-.024-.036-1.531,8.247-11.974L643.3,289.6l-.03.324-.282-12.239,7.123-12.414-7.143,10.264.074-25.356V250.1l0,.083-.473,19.984-6.492-8.117,6.471,9.839-.142,10.947-5.974-10.684,5.952,12.294-.079,6.087-.218,16.865-.016,1.26q.825.006,1.634-.027l-.374-16.2Z",
    transform: "translate(-185.393 -127.383)",
    fill: "#cbcbcb"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M662.7,275.578l-.014-.024-.036-1.531,8.247-11.974-8.237,10.828-.03.324-.282-12.239,7.123-12.414-7.143,10.264.075-25.356v-.084l0,.083-.473,19.984-6.492-8.117,6.471,9.839-.142,10.947-5.974-10.684,5.952,12.294-.079,6.087-.218,16.865-.016,1.26q.825.006,1.634-.027l-.374-16.2Z",
    transform: "translate(-185.454 -127.331)",
    fill: "#cbcbcb"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.53,
    cy: 10.53,
    r: 10.53,
    transform: "translate(140.588 418.567)",
    fill: "#0284C7"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M715.31,625.3l-9.749,3.622-18.61-35.878L701.34,587.7Z",
    transform: "translate(512.659 266.17)",
    fill: "#ed9da0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M905.3,760.932,873.866,772.61l-.148-.4a13.053,13.053,0,0,1,7.688-16.781h0l19.2-7.133Z",
    transform: "translate(328.666 139.066)",
    fill: "#2f2e41"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M619.114,635.449h-10.4l-4.948-40.113h15.349Z",
    transform: "translate(512.918 266.146)",
    fill: "#ed9da0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M804.853,772.644H771.32v-.424a13.052,13.052,0,0,1,13.051-13.052h20.482Z",
    transform: "translate(328.983 139.032)",
    fill: "#2f2e41"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M850.7,483.483,847.3,476.7l-28.841,14.421.848,5.938-5.514,7.21s-9.331,5.09-7.634,22.055l1.7,16.117,2.121,20.783-14.845,51.32L787.5,682.4l-5.514,54.714,26.721-1.272,24.6-89.069,43.262,95.855L906.257,735,865.54,639.99l-5.09-39.869s3.393-21.207-12.724-35.627l2.545-7.634v-9.408l8.483-44.882Z",
    transform: "translate(328.949 139.911)",
    fill: "#2f2e41"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 68.746,
    height: 0.997,
    transform: "translate(1161.775 786.551) rotate(-74.249)",
    opacity: 0.2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 41.565,
    height: 4.241,
    transform: "translate(1137.23 703.132)",
    fill: "#3f3d56"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.697,
    cy: 4.241,
    rx: 1.697,
    ry: 4.241,
    transform: "translate(1135.535 701.436)",
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.611,
    cy: 22.611,
    r: 22.611,
    transform: "translate(1125.285 583.588) rotate(-28.663)",
    fill: "#ed9da0"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.003,
    cy: 20.003,
    r: 20.003,
    transform: "translate(1170.573 544.505)",
    fill: "#2f2e41"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M887.217,422.285a20,20,0,1,1-39.021,8.2,20,20,0,0,0,39.021-8.2Z",
    transform: "translate(328.743 140.081)",
    fill: "#2f2e41"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M808.042,446.235a23.65,23.65,0,1,0,14.113-19.04c-3.95-3.186-8.848-2.2-12.83,1.164-4.5,3.8-5.839,6.413-9.331,12.665C803.428,441.506,804.608,445.753,808.042,446.235Z",
    transform: "translate(328.893 140.071)",
    fill: "#2f2e41"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M891.3,514.4c-.253,6.7-.755,19.891-.755,20.564,0,.709-10,21.413-14.319,30.324v0c-.307.628-.583,1.2-.827,1.7a4.016,4.016,0,0,1-3.692,2.268l-18.878-.339A4.024,4.024,0,0,1,848.878,565l-2.106-83.055a2.053,2.053,0,0,1,2.051-2.106h24.346a5.474,5.474,0,0,1,4.925,3.091l11.685,24.174a15.451,15.451,0,0,1,1.523,7.3Z",
    transform: "translate(328.748 139.901)",
    fill: "#0284C7"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M848.467,559.314a54.064,54.064,0,0,1-12.9-10.9,59.821,59.821,0,0,1-14.909-34.78c-.96-11.038,1.23-19.243,6.51-24.386,6.711-6.539,15.845-5.589,16.231-5.545l.409.046L850,488.985l-1.751,2.07-5.537-4.685c-1.695-.085-8.615-.1-13.669,4.841-4.653,4.551-6.563,12.016-5.679,22.189a57.129,57.129,0,0,0,14.164,33.133,52.494,52.494,0,0,0,12.252,10.408Z",
    transform: "translate(328.83 139.89)",
    fill: "#0284C7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 33.675,
    height: 0.904,
    transform: "matrix(0.98, -0.201, 0.201, 0.98, 1179.436, 674.427)",
    fill: "#3f3d56"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 0.904,
    height: 52.531,
    transform: "matrix(0.999, -0.041, 0.041, 0.999, 1189.782, 619.766)",
    fill: "#3f3d56"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M891.394,514.5c-.253,6.7-.755,19.891-.755,20.564,0,.709-10,21.413-14.319,30.324l8.052-46.753a10.306,10.306,0,0,1,6.692-7.948A15.165,15.165,0,0,1,891.394,514.5Z",
    transform: "translate(328.656 139.805)",
    fill: "#3f3d56"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M841.77,612.694a7.954,7.954,0,0,0-2.587-11.919l1.636-18.1-10.759-3.678-1.952,25.6a8,8,0,0,0,13.661,8.1Z",
    transform: "translate(328.808 139.593)",
    fill: "#ed9da0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M843.166,594.9l-19.064-.691.806-91.935a12.41,12.41,0,0,1,8.407-11.812,11.275,11.275,0,0,1,7.09-.006,12.411,12.411,0,0,1,8.4,12.7Z",
    transform: "translate(328.818 139.87)",
    fill: "#cbcbcb"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1009.8,772.994H629.983a1,1,0,0,1,0-1.994H1009.8a1,1,0,1,1,0,1.994Z",
    transform: "translate(329.426 138.995)",
    fill: "#cbcbcb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawAdventureMap3E4P);
export default __webpack_public_path__ + "static/media/undraw_adventure-map_3e4p.3bf663a7d98389d00cf659ed3b76df09.svg";
export { ForwardRef as ReactComponent };